import type { ReactNode } from 'react';
import { Col, Row, Text } from 'ui';

type P = {
  button: ReactNode;
  info: string;
};

const StoreButton = ({ button, info }: P) => (
  <Row gutter={[0, 'xs']}>
    <Col span={24}>
      <Text weight="medium">{info}</Text>
    </Col>
    <Col span={24}>{button}</Col>
  </Row>
);

export default StoreButton;
